import React, { useState, useEffect } from "react";
import styles from "../settings.module.scss";

import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../_store/actions/main.actions";

import Selector from "../../selector";
import Loading from "../../loading";
import TermsContainer from "./termsContainer";
import ConfirmModal from "../../modal/confirmModal";

import {
  isObjectEmpty,
  makeSelectMap,
  appOptions,
} from "../../../_utils/utils";
import t from "../../../_config/constants";

const TermsOfService = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.user);
  const [termsOfService, setTermsOfService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [termsObject, setTermsObject] = useState({});
  const [error, setError] = useState(false);
  const [regionId, setRegionId] = useState();
  const [regionOptions, setRegionOptions] = useState([]);
  const [appType, setAppType] = useState("user");
  const [refetch, setRefetch] = useState(true);
  const [editingSectionInd, setEditingSectionInd] = useState(null);
  const [loading, setLoading] = useState(false);
  const regionList = useSelector((state) => state?.main?.data?.region?.list);

  useEffect(() => {
    if (regionList && regionList.length) {
      const arr = makeSelectMap(regionList);
      setRegionOptions(arr);
    }
  }, [regionList]);
  useEffect(() => {
    setTermsOfService([]);
    if (user?.regionId && user?.regionId !== "*") {
      setRegionId(user.regionId);
    } else {
      setRegionId("");
    }
  }, [user]);
  useEffect(() => {
    const fetchTerms = async (regionId, appType) => {
      const response = await dispatch(
        mainActions.run("constants", "termsOfService", "get", {
          filter: [{ regionId, app: appType }],
        })
      );
      setTermsObject(response || {});
      setTermsOfService(response.data || []);
      setLoading(false);
    };
    if (regionId && appType) {
      setEditingSectionInd(null);
      setError(false);
      setLoading(true);
      fetchTerms(regionId, appType);
    }
  }, [regionId, appType, refetch]);

  const handleAddSection = () => {
    const ind = termsOfService.length;
    setTermsOfService((prev) => [
      ...prev,
      [
        { type: "heading", text: "" },
        { type: "subheading", text: "" },
        { type: "subsubheading", text: "" },
        { type: "baseText", text: "" },
      ],
    ]);
    setEditingSectionInd(ind);
  };

  const handleDeleteSection = async (titleInd) => {
    const deleteSection = termsOfService[titleInd];
    if (deleteSection.find((item) => item.type !== "heading" && item.text)) {
      return;
    }
    termsOfService.splice(titleInd, 1);
    setEditingSectionInd(null);

    if (!isObjectEmpty(termsObject)) {
      const response = await dispatch(
        mainActions.run("constants", "termsOfService", "update", {
          _id: termsObject._id,
          data: [...termsOfService],
        })
      );
      setTermsObject(response || {});
      setTermsOfService(response?.data || []);
    } else {
      setTermsOfService([...termsOfService]);
    }
  };
  const handleDeleteField = async (answer, { titleInd, ind }) => {
    setShowModal(false);
    if (answer) {
      if (!termsOfService[titleInd]) return;
      termsOfService[titleInd].splice(ind, 1);
      setTermsOfService([...termsOfService]);
    }
    setModalData();
  };

  const handleAddField = (titleInd, fieldType) => {
    termsOfService[titleInd].push({ type: fieldType, text: "" });
    setTermsOfService([...termsOfService]);
  };
  const deleteField = (titleInd, ind) => {
    if (!termsOfService[titleInd]) return;
    const section = termsOfService[titleInd][ind];
    if (section?.text) {
      setShowModal(true);
      setModalData({ titleInd, ind });
      return;
    }
    termsOfService[titleInd].splice(ind, 1);
    setTermsOfService([...termsOfService]);
  };
  const handleChangeHeading = (e, headingInd) => {
    const { value, name } = e.target;
    termsOfService[headingInd].find((item) => item.type === name).text = value;
    setTermsOfService([...termsOfService]);
    setError(false);
  };
  const handleSelect = (e, type) => {
    if (type === "app") {
      setAppType(e.value);
    } else {
      setRegionId(e.value);
    }
  };
  const handleChange = (e, titleInd, fieldInd) => {
    setError(false);
    const { value } = e.target;
    termsOfService[titleInd][fieldInd].text = value;
    setTermsOfService([...termsOfService]);
  };
  const handleSubmit = async (titleInd) => {
    const section = termsOfService[titleInd];
    if (
      regionId &&
      appType &&
      section.length &&
      !section?.find((item) => !item.type || !item.text)
    ) {
      setLoading(true);
      const objectForDb = {};
      objectForDb.data = [...termsOfService];
      setEditingSectionInd(null);
      if (isObjectEmpty(termsObject)) {
        objectForDb.regionId = regionId;
        objectForDb.app = appType;
      } else {
        objectForDb._id = termsObject._id;
      }
      const response = await dispatch(
        mainActions.run(
          "constants",
          "termsOfService",
          objectForDb?._id ? "update" : "new",
          objectForDb
        )
      );
      setTermsObject(response || {});
      setTermsOfService(response?.data || []);
      setLoading(false);
    } else {
      setError(true);
    }
  };
  const handleCancel = () => {
    setEditingSectionInd(null);
    setRefetch((prev) => !prev);
    setError(false);
  };

  const getSelectedValue = (options, value) => {
    const selectedData = [];
    options &&
      options.forEach((obj) => {
        if (obj.value === value) {
          selectedData.push(obj);
        }
      });
    return selectedData;
  };
  return (
    <div className={styles.wrapper}>
      <h3>{t.app_settings.terms_of_service}</h3>{" "}
      {showModal && (
        <ConfirmModal
          show={showModal}
          handleYesNoAnswer={handleDeleteField}
          modalData={modalData}
          question="Are you sure you want to delete this field?"
        />
      )}
      {!user.regionId ||
        (user.regionId === "*" && (
          <Selector
            options={regionOptions}
            placeholder={"Select Region"}
            handleChangeSelect={(e) => handleSelect(e)}
            selectClassname="selectSecondaryWhiteBg"
            disabled={loading}
          />
        ))}
      <Selector
        options={appOptions}
        handleChangeSelect={(e) => handleSelect(e, "app")}
        selectedOption={getSelectedValue(appOptions, appType)}
        selectClassname="selectSecondaryWhiteBg"
        disabled={loading}
      />
      {!loading && (
        <div className={styles.content}>
          {termsOfService.map((item, ind) => (
            <TermsContainer
              key={ind}
              titleInd={ind}
              data={item}
              handleAddField={handleAddField}
              deleteSection={handleDeleteSection}
              deleteField={deleteField}
              handleChangeHeading={handleChangeHeading}
              handleChange={handleChange}
              editingSectionInd={editingSectionInd}
              setEditingSectionInd={setEditingSectionInd}
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
              errorMsg={error}
            />
          ))}
          {editingSectionInd === null && regionId && (
            <div className={styles.addSection} onClick={handleAddSection}>
              <span>+</span>
              <p>Add Section</p>
            </div>
          )}
        </div>
      )}
      {loading && <Loading height={60} width={60} />}
    </div>
  );
};

export default TermsOfService;
